<template>
  <div class="go-in">
    <banner :img="banner" title="走进漫漫" />
    <div class="section" v-loading="loading">
      <div class="section-content">
        <div class="content-summary">
          <div class="summary-left">
            <p class="title">公司介绍</p>
            <!-- <p class="eTitle">ABOUT US</p> -->
            <p class="content">
            珠海漫漫科技有限公司成立于2017年7月，位于珠海横琴粤澳深度合作区十字门大道338号，系卫星技术应用领域的创新型企业，通过卫星遥感、人工智能、大数据等技术的应用，为海洋、农业等领域用户提供“一站式”的敏捷服务。 公司是国内海洋信息服务领域的领先企业，目前拥有软件著作权29项，其中卫星图像处理、渔场渔情预报、农作物管理应用等技术水平处在国内前列。潜心研发的渔鹰渔场预报服务平台，成功解决了渔民捕鱼仅凭运气和经验的高风险、低效益的作业模式，帮助渔民精准定位渔场，高效捕鱼，节省成本费用，同时简洁易用、高效便捷的功能界面广受用户的好评。 公司拥有实力雄厚的国际化产品研发和运营团队，包括多名卫星遥感和云计算领域的国际知名专家，加拿大渥太华设有分支机构。
            </p>
          </div>
          <div class="summary-right">
            <img src="../assets/img/manmangongsi2.png" alt />
          </div>
        </div>
        <div>
          <ul class="company-wrap">
            <li>
              <img src="../assets/img/company1.png" alt="">
            </li>
            <li>
              <img src="../assets/img/company2.png" alt="">
            </li>
            <li>
              <img src="../assets/img/company3.png" alt="">
            </li>
          </ul>
        </div>
        <el-divider class="el-divider-active">
          <i class="el-icon-arrow-down el-icon-arrow-down-active"></i>
        </el-divider>
        <!-- 发展历程 -->
        <!-- <div class="content-course">
          <div class="top">
            <h3>发展历程</h3>
            <p>DEVELOPMENT</p>
            <div class="border"></div>
            <div class="timeline"></div>
          </div>
          <div class="course-time">
            <swiper :options="swiperOption" ref="mySwiper">
              <swiper-slide v-for="(item,index) in courseList" :key="index">
                <div class="time-show">
                  <div class="time-show-item" v-for="(courseOne,one) in item" :key="one">
                    <div class="item-top" :class="{'order-top' : one%2===1}"></div>
                    <el-divider>
                      <i class="el-icon-mobile-phone"></i>
                    </el-divider>
                    <div class="item-bottom" :class="{'order' : one%2===1}">
                      <div class="item-bottom-content">
                        <p>{{courseOne.Content}}</p>
                        <p>{{courseOne.Year}}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </swiper-slide>
              <div class="swiper-button-prev" slot="button-prev"></div>
              <div class="swiper-button-next" slot="button-next"></div>
            </swiper>
          </div>
        </div> -->

        <!-- <div class="content-culture">
          <h3>企业文化</h3>
          <h3>CULTURE</h3>
          <p>我们只专注一件事情——工程项目管理</p>
          <span>确保工程无重大安全事故</span>
          <span>确保工程施工单位无大面积返工</span>
          <span>确保工程材料及设备无伪劣产品</span>
          <span>确保工程管理留下痕迹、实施过程可追溯</span>
        </div> -->
        <!-- 公司荣誉 -->
        <div class="content-honor">
          <!-- <div class="honor-big-img">
            <el-dialog :title="dialogTitle" :visible.sync="dialogTableVisible">
              <img v-lazy="dialogUrl" alt />
            </el-dialog>
          </div> -->
          <div class="top">
            <h3>荣誉资质</h3>
            <div class="border"></div>
            <p>
             珠海漫漫科技有限公司现有软件著作权29项，包括“渔业大数据服务系统”、“带鱼渔情预报系统”、“多源异构渔业数据汇聚系统”、“海洋大数据管理平台”及“海洋环境数据处理系统”等。
            </p>
            <!-- <p>HONOR</p> -->
          </div>
          <ul class="honor-show">
            <li v-for="(honor,index) in honorList" :key="index">
              <img
                v-lazy="honor.url"
                @click="dialogTableVisible = true ;dialogUrl = honor.url;dialogTitle= honor.title"
              />
            </li>

          </ul>
          <!-- <p style="text-align: center">点击图片查看大图</p> -->
        </div>
        <!-- 团队风采 -->
        <!-- <div class="content-team">
          <div class="top">
            <h3>团队风采</h3>
            <p>TEAM</p>
          </div>
          <el-carousel :interval="4000" type="card">
            <el-carousel-item v-for="(team,index) in teamItem" :key="index">
              <div class="swiper-img" v-lazy:background-image="imgserver + team.Img"></div>
            </el-carousel-item>
          </el-carousel>
        </div> -->
        <!-- 合作伙伴 -->
        <div class="content-partner">
          <div class="top">
            <h3>合作伙伴</h3>
            <div class="border"></div>
          </div>
          <ul class="partner-show">
            <li v-for="(partner,index) in partnerList" :key="index">
              <img v-lazy="partner.url"/>
              <span>{{partner.title}}</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Banner from "../components/Banner";
// import { swiperSlide } from "vue-awesome-swiper";
export default {
  components: {
    Banner,
    // swiper,
    // swiperSlide
  },
  data() {
    return {
      loading: false,
      banner:require("../assets/img/chanpinBanner.png"),
      honorList: [
        {
          url: require("../assets/img/honor0.jpg" ),
          title:'渔业大数据服务系统'
        },
        {
          url: require("../assets/img/honor1.jpg" ),
          title:'带鱼渔情预报系统'
        },
        {
          url: require("../assets/img/honor2.jpg" ),
          title:'多源异构渔业数据汇聚系统'
        },
        {
          url: require("../assets/img/honor3.jpg" ),
          title:'海洋大数据管理平台'
        },
        {
          url: require("../assets/img/honor4.jpg" ),
          title:'海洋环境数据处理系统'
        },
        {
          url: require("../assets/img/honor5.jpg" ),
          title:'海洋上升流识别系统'
        },
        {
          url: require("../assets/img/honor6.jpg" ),
          title:'海洋污染监测预警系统'
        },
        {
          url: require("../assets/img/honor7.jpg" ),
          title:'海洋灾害预警系统'
        }
      ],
      partnerList: [
        {
          url: require("../assets/img/partner/瑞士弗里堡大学.png" ),
          title:'瑞士弗里堡大学'
        },

        {
          url: require("../assets/img/partner/中国东海水产.jpg" ),
          title:'中国东海水产研究所'
        },

                {
          url: require("../assets/img/partner/中国南海水产研究所.jpg" ),
          title:'中国南海水产研究所'
        },
        {
          url: require("../assets/img/partner/中国科学院遥感与数字地球研究所.png" ),
          title:'中科院遥感与数字地球研究所'
        },


        {
          url: require("../assets/img/partner/加拿大海洋科学研究所.png" ),
          title:'加拿大海洋科学研究所'
        },
        {
          url: require("../assets/img/partner/北京大学.png" ),
          title:'北京大学'
        },
        {
          url: require("../assets/img/partner/日本东京大学.jpg" ),
          title:'日本东京大学'
        },
        {
          url: require("../assets/img/partner/美国国家海洋和大气管理局.png" ),
          title:'美国国家海洋和大气管理局'
        }
      ],
      partnerImg: [],
      courseList: [],
      teamItem: [],
      swiperOption: {
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        }
      },
      dialogTableVisible: false,
      dialogUrl: "",
      dialogTitle: "",
    };
  }
};
</script>

<style lang="scss" scoped>
* {
  margin: 0;
  padding: 0;
}

.go-in {
  width: 100%;
  height: 100%;
  // background-color: #14679f;
  position: relative;
  overflow: hidden;
  .section {
    width: 100%;
    &-content {
      width: 1240px;
      margin: 0 auto;
      background-color: #fff;

      .content-summary {
        //height: 500px;
        display: flex;
        justify-content: space-around;
        padding: 100px 0;
        .summary-left {
          width: 600px;
          .title {
            font-size: 25px;
            color: #303133;
            text-align: center;
            margin-bottom: 10px;
          }
          .content {
            color: #303133;
            font-size: 16px;
            text-indent: 32px;
            line-height: 2;
          }
        }

        .summary-right {
          width: 451px;
          height: 349px;
          // border: 1px solid gray;
          //animation: imgboxkey 4s infinite;
          border-radius: 10px;
          text-align: center;

          img {
            width: 450px;
            height: 348px;
            //animation: imgbo 4s infinite;
          }
        }
      }

      //发展历程
      .content-course {
        padding: 50px 0;
        .course-time {
          width: 1000px;
          height: 400px;
          margin: 20px auto;
          .swiper-container {
            height: 100%;
          }
          .time-show {
            width: 700px;
            height: 100%;
            margin: 0 auto;
            display: flex;
            .time-show-item {
              width: 350px;
              height: 100%;
              overflow: hidden;
              display: flex;
              flex-direction: column;

              .item-top,
              .item-bottom {
                height: 190px;
              }
              .item-bottom {
                // display: flex;
                // align-content: center;
                .item-bottom-content {
                  background-color: #1667a0;
                  margin: 20px 0;
                  p {
                    color: #fff;
                    text-align: center;
                    padding: 15px;
                  }
                }
              }
            }
          }
        }
      }

      //企业文化
      .content-culture {
        height: 450px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: flex-start;
        padding-left: 100px;
        background-color: #c2daeb;
        h3 {
          color: #3c6088;
          font-size: 26px;
        }
        p {
          color: #3c6088;
          font-size: 26px;
          padding: 5px 0;
        }
        span {
          font-weight: 400;
          line-height: 36px;
          font-size: 18px;
          padding: 5px 0;
        }
      }

      //公司荣誉
      .content-honor {
        padding: 50px 0;
        .honor-show {
          width: 1001px;
          margin: 30px auto;
          display: flex;
          flex-wrap: wrap;
          justify-content: flex-start;
          align-content: flex-start;

          li {
            height: 320px;
            margin-left: 15px;
            list-style: none;
            margin-top: 20px;;
            // border: 1px solid palegoldenrod;

            img {
              width: 100%;
              height: 100%;
            }
          }
        }
        p {
          // text-align: center;
          color: #303133;
          padding-left: 100px;
          padding-right: 100px;
        }
      }

      //团队风采
      .content-team {
        padding: 50px 100px;
        .swiper-img {
          height: 400px;
          background: no-repeat center;
          background-size: cover;
        }
      }

      //合作伙伴
      .content-partner {
        padding: 50px 0;
        .partner-show {
          width: 1000px;
          margin: 30px auto;
          display: flex;
          flex-wrap: wrap;
          justify-content: flex-start;
          align-content: flex-start;

          li {
            width: 220px;
            height: 220px;
            margin-left: 15px;
            list-style: none;
            margin-top: 20px;
            display: -webkit-box;
            display: -ms-flexbox;
            display: flex;
            -webkit-box-orient: vertical;
            -webkit-box-direction: normal;
            -ms-flex-direction: column;
            flex-direction: column;
            -webkit-box-align: center;
            -ms-flex-align: center;
            align-items: center;
            -ms-flex-pack: distribute;
            justify-content: space-around;
            position: relative;
            img {
              max-height: 132px;
              max-width: 132px;
            }
            span{
             position: absolute;
            bottom: 0;
            }
          }
        }
        p {
          // text-align: center;
          position: absolute;
          bottom: 0;

        }
      }
    }
  }
}

.company-wrap{
    display: flex;
    justify-content: center;
    margin-bottom: 160px;
    li{
      list-style: none;
      width: 450px;
      height: 230px;
      text-align: center;
      img{
        height: 100%;
        width: auto;
      }
    }
}

@keyframes imgboxkey {
  0% {
    border: solid rgb(29, 66, 185) 2px;
  }
  40% {
    border: solid rgb(255, 255, 255) 2px;
  }
  60% {
    border: solid rgb(255, 255, 255) 2px;
  }
  100% {
    border: solid rgb(29, 66, 185) 2px;
  }
}

@keyframes imgbo {
  0% {
    transform: scale(1);
    box-shadow: 0px 0px 0px 0px #ababab;
  }
  50% {
    transform: scale(1.1);
    box-shadow: 0px 0px 10px 5px #ababab;
  }
  100% {
    transform: scale(1);
    box-shadow: 0px 0px 0px 0px #ababab;
  }
}
.el-divider--horizontal {
  margin: 1px 0;
}

.top {
  h3,
  p {
    text-align: center;
    color: #3c6088;
    font-weight: 400;
    padding: 10px 0;
  }
  h3 {
    font-size: 30px;
  }
  p {
    font-size: 16px;
    text-align: left;
    line-height: 2;
    text-indent: 32px;
  }
  .border {
    border-bottom: 1px solid #3c6088;
    width: 15%;
    margin: 0 auto;
  }
}
// .swiper-button-disabled {
//   display: none;
// }
.order {
  order: -1;
}
.order-top {
  order: 1;
}
.el-divider {
  background-color: red;
  height: 3px;
  .el-divider__text {
    width: 20px;
    height: 20px;
    border-radius: 50%;
    padding: 0px;
    color: #fff;
    border: 3px solid gray;
  }
}
.el-divider-active {
  background-color: #3c6088;
}
.honor-big-img {
  width: 100%;
  height: 100%;
  z-index: 10;
  text-align: center;
  padding-bottom: 20px;
  padding: 5%;
  //background-color: #14679f;
  .el-dialog__wrapper {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    overflow: auto;
    margin: 0;

    .el-dialog__body {
      overflow: hidden;
      img {
        width: 100%;
      }
    }
  }
}
</style>